@if (modalMode && (errorInfo || configureServiceError)) {
  <div class="header udex-mt-12 udex-mb-24 udex-mb-sm-32 udex-px-32">
    <div class="d-flex align-items-center justify-conten-end udex-mb-12">
      <div class="flex-grow-1 d-flex flex-column justify-content-center">
        <h1 class="heading__medium--xs">{{ heading }}</h1>
      </div>
      <udex-control-button
        (click)="closeModal()"
        icon="decline"
        size="Large"
        [tooltip]="'common.close' | cxTranslate"
        accessible-role="Button"
        [attr.accessible-name]="'common.close' | cxTranslate"></udex-control-button>
    </div>
  </div>
}

<div [ngClass]="!modalMode ? 'udex-p-32' : ''">
  @if (!errorInfo && !configureServiceError) {
    <dcp-edit-cart-entry
      (multiCurrencyCartError)="addMultiCurrencyErrorInfo($event)"
      (setHeader)="setHeading($event)"
      [cartEntry]="cartEntry"></dcp-edit-cart-entry>
  }
  @if (errorInfo) {
    <dcp-multi-currency-cart-error
      [errorInfo]="errorInfo"
      [errorMsgMainText]="componentTexts?.errorMessageMainText"
      [errorMsgTheadText]="componentTexts?.errorMessageTHeadText"></dcp-multi-currency-cart-error>
  }
  <dcp-configure-service-error
    [modalHeaderDisplay]="!!modalMode"
    (setHeader)="setHeading($event)"
    (configureServiceError)="processConfigureServiceError($event)"></dcp-configure-service-error>
</div>
